import { render } from "./ObjectSpace.vue?vue&type=template&id=4ec362ff&scoped=true"
import script from "./ObjectSpace.vue?vue&type=script&lang=js"
export * from "./ObjectSpace.vue?vue&type=script&lang=js"

import "./ObjectSpace.vue?vue&type=style&index=0&id=4ec362ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec362ff"]])

export default __exports__